export default __webpack_public_path__ + "resources/icons/d442-2e22.png";